import { MenuItem } from "@mui/material";
import dayjs from "dayjs";

export const defaultAddress = {
  street: "",
  street_number: "",
  cap: "",
  city: "",
  country: "",
};

export const validatePassword = (password) => {
  const validations = [
    {
      test: /.{12,}/,
      message: "La password deve contenere almeno 12 caratteri",
    },
    {
      test: /\d/,
      message: "La password deve contenere almeno un numero",
    },
    {
      test: /[A-Z]/,
      message: "La password deve contenere almeno una lettera maiuscola",
    },
    {
      test: /[a-z]/,
      message: "La password deve contenere almeno una lettera minuscola",
    },
    {
      test: /[!@#$%^&*(),.?":{}|<>]/,
      message: "La password deve contenere almeno un carattere speciale",
    },
  ];

  for (const rule of validations) {
    if (!rule.test.test(password)) {
      return rule.message;
    }
  }
  return true;
};

export const dialogMessages = {
  user: {
    create: {
      title: "Nuovo Utente aggiunto!",
      description:
        "Una mail con la nuova registrazione è stata inviata all'utente",
    },
    update: {
      title: "Utente aggiornato con successo!",
      description: "I dati dell'utente sono stati aggiornati correttamente.",
    },
    block: {
      title: "Conferma blocco utente",
      description:
        "Sei sicuro di voler bloccare questo utente? Potrà essere riattivato in seguito.",
      confirmLabel: "Blocca",
    },
    unblock: {
      title: "Conferma attivazione utente",
      description: "Sei sicuro di voler riattivare questo utente?",
      confirmLabel: "Attiva",
    },
    delete: {
      title: "Elimina Utente",
      description: "Sei sicuro di voler eliminare questo utente?",
      confirmLabel: "Elimina",
    },
  },
  culture: {
    create: {
      title: "Nuova Coltura aggiunta!",
      description: "La coltura è stata aggiunta correttamente.",
    },
    update: {
      title: "Coltura aggiornata con successo!",
      description: "I dati della coltura sono stati aggiornati correttamente.",
    },
    delete: {
      title: "Elimina Coltura",
      description: "Sei sicuro di voler eliminare questa coltura?",
      confirmLabel: "Elimina",
    },
  },
  fieldType: {
    create: {
      title: "Nuova tipologia terreno aggiunta!",
      description: "La tipologia terreno è stata aggiunta correttamente.",
    },
    update: {
      title: "Tipologia terreno aggiornata con successo!",
      description:
        "I dati della tipologia terreno sono stati aggiornati correttamente.",
    },
    delete: {
      title: "Elimina Tipologia terreno",
      description: "Sei sicuro di voler eliminare questa tipologia terreno?",
      confirmLabel: "Elimina",
    },
  },
  irrigationType: {
    create: {
      title: "Nuova tipologia di irrigazione aggiunta!",
      description:
        "La tipologia di irrigazione è stata aggiunta correttamente.",
    },
    update: {
      title: "Tipologia di irrigazione aggiornata con successo!",
      description:
        "I dati della tipologia di irrigazione sono stati aggiornati correttamente.",
    },
    delete: {
      title: "Elimina Tipologia di irrigazione",
      description:
        "Sei sicuro di voler eliminare questa tipologia di irrigazione?",
      confirmLabel: "Elimina",
    },
  },
  addCustomerField: {
    title: "Ben fatto, Nuovo Terreno aggiunto!",
    description: "Potrai visualizzarlo e modificarlo quando necessario",
    goDashboardButton: "Vai alla dashboard",
    goFieldButton: "Visualizza terreno",
  },
  deleteCustomerField: {
    title: "Elimina terreno",
    description: "Sei sicuro di voler eliminare questo terreno?",
    confirmLabel: "Elimina",
  },
  deleteTool: {
    title: "Elimina strumento",
    description: "Sei sicuro di volere eliminare questo strumento?",
  },
  addToolRequest: {
    title: "Richiesta inviata con successo!",
    description: "Riceverai una notifica quando lo strumento sarà disponibile",
  },
  addSensor: {
    title: "Ben fatto, Nuovo sensore aggiunto!",
    description: "Potrai visualizzarlo e modificarlo quando necessario",
  },
  updateSensorField: {
    title: "Modifica terreno",
    description:
      "Hai collegato il sensore ad un altro terreno, vai sul nuovo terreno e riposizionalo.",
    confirmButton: "Ok, ho capito",
    closeButton: "Annulla",
  },
  bulkDeleteInstruments: {
    title: "Elimina strumenti",
    description: "Sei sicuro di voler eliminare questi strumenti?",
  },
  noteBook: {
    delete: {
      title: "Elimina nota",
      description: "Sei sicuro di voler eliminare questa nota?",
    },
  },
};

export const renderMenuItems = (items) => {
  if (!items || items.length === 0) {
    return (
      <MenuItem value="" disabled>
        Nessuna opzione
      </MenuItem>
    );
  }
  return items.map((item) => (
    <MenuItem key={item.id} value={item.id}>
      {item.name}
    </MenuItem>
  ));
};

export const handleDateChange = (key, date, handleChange) => {
  if (date) {
    const dateString = dayjs(date).format("YYYY-MM-DD");
    handleChange(key, dateString);
  } else {
    handleChange(key, null);
  }
};

export const getFieldTypeName = (fieldsType, id) => {
  const type = fieldsType.find((type) => type.id === id);
  return type ? type.name : null;
};
